import { render } from "./BLActionWidget.vue?vue&type=template&id=161515d8"
import script from "./BLActionWidget.vue?vue&type=script&lang=js"
export * from "./BLActionWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__